import useMobileView from "./useMobileView.tsx";
export const useBreakpoints = () => {
    const isPhoneSmallWidth = useMobileView(480);
    const isPhoneWidth = useMobileView(768);
    const isTabletWidth = useMobileView(1024);
    return {
        isPhoneSmallWidth,
        isPhoneWidth,
        isTabletWidth,
    };
};
